import { Rating } from "@material-ui/lab";
import React, { useState } from "react";

function Feadback(props) {
  const { requestData, feedback, setFeedback, submitFeedback } = props;
  const { id } = requestData.request;
  const { first_name, last_name } = requestData.request_customer;

  const handleClick = () => {
    if (feedback.rating === 0) {
      return;
    }

    document.getElementById("close-feedback").click();
    submitFeedback();
  };

  return (
    <>
      <div
        className="modal fade feedback"
        id="feedback"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="feedback-title"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content pb-30">
            <div className="modal-header text-center border-0 pb-0">
              <button
                type="button"
                className="close black-color"
                data-dismiss="modal"
                aria-label="Close"
                id="close-feedback"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="form-wrapper pl-4 pr-4 pl-sm-5 pr-sm-5">
              <div className="modal-body p-0">
                <h5 className="text-center" id="feedback-title">
                  Feedback
                </h5>
                <p className="text-center sub-title pb-4 mb-3 pt-3">
                  How was your move?
                </p>
                <div className="row pb-3">
                  {/* <div className="col-3">
                    <div className="profile-pic-small">
                      <img
                        src="../images/user-img1.png"
                        className="rounded-circle circle-box circle-box-small"
                      />
                    </div>
                  </div> */}
                  <div className="col-9">
                    <div className="sub-title user-name">
                      {first_name + " " + last_name}
                    </div>
                    <div className="dark-grey-color small-font-size">
                      Request #{id}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <label
                      htmlFor="distance"
                      className="overline dark-grey-color"
                    >
                      Rate
                    </label>
                    <div className="star-rating">
                      <Rating
                        size="large"
                        value={feedback.rating}
                        precision={0.5}
                        onChange={(e) =>
                          setFeedback({ ...feedback, rating: e.target.value })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="feedback-comment-box pt-3">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label
                          htmlFor="distance"
                          className="overline dark-grey-color"
                        >
                          Comment
                        </label>
                        <textarea
                          required
                          className="form-control small-font-size text-area"
                          placeholder="Please describe here what went great with that client, how a client was treating your moving crew during the move?"
                          value={feedback.comments}
                          onChange={(e) =>
                            setFeedback({
                              ...feedback,
                              comments: e.target.value,
                            })
                          }
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`row justify-content-center pt-3 ${
                    window.innerHeight < 700 && "pb-5"
                  }`}
                >
                  <div className="col-12 col-sm-10">
                    <button
                      onClick={handleClick}
                      type="button"
                      className="red-btn custom-buton custom-buton-large w-100"
                    >
                      Leave Feedback
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Feadback;
